import { render, staticRenderFns } from "./OurShop.vue?vue&type=template&id=3bc61ae9&"
import script from "./OurShop.vue?vue&type=script&lang=js&"
export * from "./OurShop.vue?vue&type=script&lang=js&"
import style0 from "./OurShop.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports